// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__23lsM","additionalInfo":"AgreementModal_additionalInfo__2b7Zn"};